export const etherSounds = {
  closerSound: "/closer-ether-sound.mp3",
  farSound: "/new-order.mp3",
};

export const farSoundDistance = 300;
